// ADD THESE IMPORTS
import React, { useState, useEffect } from "react";
import "./inventoryadmin.css";
import {  } from "firebase/firestore";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from "xlsx";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  getDoc,
  addDoc,
  updateDoc,
  query,
  orderBy,
  limit,
  where,
  serverTimestamp,
  arrayUnion,
  runTransaction,

} from "firebase/firestore";
import { saveAs } from 'file-saver';
import { db } from "../FirebaseComp/firebase"; // adjust your path


import { Bar, Doughnut, Line } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title } from 'chart.js';

// Register ChartJS components
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title);



function InventoryAdminPanel() {
const [openMenu, setOpenMenu] = useState(null); 

  const [selectedOption, setSelectedOption] = useState("dashboard");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpenStock, setDropdownOpenStock] = useState(false);
  const [dropdownOpenSupplier, setDropdownOpenSupplier] = useState(false);
  const [dropdownOpenReport, setDropdownOpenReport] = useState(false);
  const [dropdownOpenInvoice, setDropdownOpenInvoice] = useState(false);




// ✅ State variables MUST come first
const [suppliers, setSuppliers] = useState([]);
const [lensList, setLensList] = useState([]);
const [frameList, setFrameList] = useState([]);
const [supplierName, setSupplierName] = useState("");
const [purchaseOrderNo, setPurchaseOrderNo] = useState("");




const [purchaseOrders, setPurchaseOrders] = useState([]);

const [purchaseDate, setPurchaseDate] = useState("");
const [items, setItems] = useState([]);



useEffect(() => {
  const close = () => setOpenMenu(null);
  document.addEventListener("click", close);
  return () => document.removeEventListener("click", close);
}, []);


  const handleSelect = (option) => {
    setSelectedOption(option);
    setDropdownOpen(false);
  };

    const handleSelectStock = (optionstock) => {
    setSelectedOption(optionstock);
    setDropdownOpenStock(false);
  };


    const handleSelectSupplier = (optionsupplier) => {
    setSelectedOption(optionsupplier);
    setDropdownOpenSupplier(false);
  };



      const handleSelectInvoice = (optioninvoice) => {
    setSelectedOption(optioninvoice);
    setDropdownOpenInvoice(false);
  };



  
    const handleSelectReport = (optionsReport) => {
    setSelectedOption(optionsReport);
    setDropdownOpenReport(false);
  };













const handleLogout = () => {
  // Remove login token / session
  localStorage.removeItem("adminToken");

  // Redirect to login page
  window.location.href = "/";
};





//////////////////////////////////////////// Add Supplier //////////////////////////////////////////////////// 

  const [supplierForm, setSupplierForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    address: ""
  });

  // Handle input changes
  const handleSupplierChange = (e) => {
    setSupplierForm({ ...supplierForm, [e.target.name]: e.target.value });
  };

  // Submit & save to Firestore
  const handleSupplierSubmit = async (e) => {
    e.preventDefault();

    if (!supplierForm.name || !supplierForm.phone) {
      alert("Name and Phone are required!");
      return;
    }

    try {
      await addDoc(collection(db, "suppliers"), {
        ...supplierForm,
        createdAt: serverTimestamp()
      });

      alert("Supplier added successfully!");

      setSupplierForm({
        name: "",
        email: "",
        phone: "",
        company: "",
        address: ""
      });

    } catch (error) {
      console.error("Error adding supplier:", error);
      alert("Failed to save supplier. Check console for error.");
    }
  };



/////////////////////////////////////////////////////// view supplier ////////////////////////////////////////////////////////////


  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [sortType, setSortType] = useState("newest");
  const [currentPage, setCurrentPage] = useState(1);
  const [editData, setEditData] = useState(null);

  const itemsPerPage = 5;

  // FETCH DATA
  const fetchSuppliers = async () => {
    try {
      const q = query(collection(db, "suppliers"), orderBy("createdAt", "desc"));
      const snapshot = await getDocs(q);
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSuppliers(list);
      setFiltered(list);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  // SEARCH
  useEffect(() => {
    let data = [...suppliers];

    if (search) {
      data = data.filter((s) =>
        s.name.toLowerCase().includes(search.toLowerCase())
      );
    }

    // SORT
    if (sortType === "az") {
      data.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortType === "newest") {
      data.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);
    }

    setFiltered(data);
    setCurrentPage(1);
  }, [search, sortType, suppliers]);

  // DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this supplier?")) return;
    await deleteDoc(doc(db, "suppliers", id));
    fetchSuppliers();
  };

  // UPDATE
  const handleUpdate = async () => {
    try {
      const ref = doc(db, "suppliers", editData.id);
      await updateDoc(ref, {
        name: editData.name,
        email: editData.email,
        phone: editData.phone,
        company: editData.company,
        address: editData.address,
      });
      setEditData(null);
      fetchSuppliers();
    } catch (err) {
      console.error(err);
    }
  };

  // PAGINATION
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / itemsPerPage);


 
  






/////////////////////////////////////////// Add Stock //////////////////////////////////////////////
const [selectedCategory, setSelectedCategory] = useState(""); 
const [isQuickAdding, setIsQuickAdding] = useState(false);

useEffect(() => {
  const fetchPurchaseOrders = async () => {
    const q = query(
      collection(db, "purchasing_order"),
      orderBy("createdAt", "desc")
    );
    const snapshot = await getDocs(q);
    const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setPurchaseOrders(list);
  };

  fetchPurchaseOrders();
}, []);








const handleAddItems = async () => {
  if (isQuickAdding) return; // Prevent multiple clicks
  
  setIsQuickAdding(true);
  
  try {
    await addDoc(collection(db, "stock"), {
      supplierName,
      category: selectedCategory,
      purchaseDate,
      items,
      createdAt: serverTimestamp()
    });

    alert("Stock added successfully!");
    handleClear();
  } catch (err) {
    console.error(err);
    alert("Failed to add stock.");
  } finally {
    setIsQuickAdding(false);
  }
};




  // Clears the form fields
const handleClear = () => {
  setPurchaseOrderNo("");
  setSupplierName("");
  setPurchaseDate("");
  setSelectedCategory("");
  setItems([]);
};











// Example: Update quantity of an item
const handleSupplyQtyChange = (index, value) => {
  const updatedItems = [...items];
  updatedItems[index].supplyQty = value;
  setItems(updatedItems);
};



  const [frameForm, setFrameForm] = useState({
    modelNo: "",
    brand: "",
    colour: "",
    sex: "",
    qty: ""
  });



  const handleFrameAdd = () => {
    setFrameList([...frameList, frameForm]);
    setFrameForm({
      modelNo: "",
      brand: "",
      colour: "",
      sex: "",
      qty: ""
    });
  };


const handleItemFieldChange = (index, field, value) => {
  const updatedItems = [...items];
  updatedItems[index][field] = value;
  setItems(updatedItems);
};










  

// Clear Entire List
const clearList = () => {
  setLensList([]);
};


/////////////////////////////////////////////////////////////////////// Add Suppliers//////////////////////////////////////////////

// Add Supplier states
const [supplierEmail, setSupplierEmail] = useState("");
const [supplierPhone, setSupplierPhone] = useState("");
const [supplierCompany, setSupplierCompany] = useState("");
const [supplierAddress, setSupplierAddress] = useState("");


// Add Supplier handler
const handleAddSupplier = async () => {
  // Validation
  if (!supplierName.trim()) return alert("Supplier Name is required");

  
  // Email validation (if provided)
  if (supplierEmail && !/\S+@\S+\.\S+/.test(supplierEmail)) {
    return alert("Please enter a valid email address");
  }

  try {
    await addDoc(collection(db, "suppliers"), {
      name: supplierName.trim(),
      email: supplierEmail.trim() || null,
      phone: supplierPhone.trim(),
      company: supplierCompany.trim(),
      address: supplierAddress.trim(),
      createdAt: serverTimestamp()
    });

    alert("Supplier added successfully!");
    handleClearSupplier();
  } catch (err) {
    console.error(err);
    alert("Failed to add supplier.");
  }
};

// Clear Supplier form
const handleClearSupplier = () => {
  setSupplierName("");
  setSupplierEmail("");
  setSupplierPhone("");
  setSupplierCompany("");
  setSupplierAddress("");
};






  


//////////////////////////////////////////////////////////////////////Hisotry report - stock history/////////////////////////////////////////////////////////
 const [summarySearchTerm, setSummarySearchTerm] = useState("");

const [historyCategory, setHistoryCategory] = useState("frame");
const [frameStockHistory, setFrameStockHistory] = useState([]);
const [loading, setLoading] = useState(false);
const [filterType, setFilterType] = useState("all"); // "all", "day", "month", "year"
const [filterValue, setFilterValue] = useState("");
const [filteredLensHistory, setFilteredLensHistory] = useState([]);
const [filteredFrameHistory, setFilteredFrameHistory] = useState([]);

const [stockSearchTerm, setStockSearchTerm] = useState("");



// FETCH ALL STOCK (WITHOUT CATEGORY FILTER OR USE APPROPRIATE CATEGORY)
useEffect(() => {
  const fetchStockHistory = async () => {
    setLoading(true);

    try {
      // Option 1: Fetch all stock documents (since category is empty in your data)
      const q = query(
        collection(db, "stock"),
        orderBy("createdAt", "desc")
      );
      
      // OR Option 2: If you want to keep category filter but your data has empty category
      // const q = query(
      //   collection(db, "stock"),
      //   where("category", "in", ["frame", ""]), // Include both "frame" and empty strings
      //   orderBy("createdAt", "desc")
      // );

      const snapshot = await getDocs(q);
      
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Filter to only include frame-related stock
      // Since your data doesn't have category set, you might need to
      // identify frame stock by checking items or other criteria
      const frameData = data.filter(stock => {
        // Check if it's frame stock based on your criteria
        // For now, include all since your sample shows frame items
        return true; // Adjust this based on your needs
      });

      setFrameStockHistory(frameData);
      console.log("Fetched stock data:", frameData); // Debug log

    } catch (err) {
      console.error("Fetch error:", err);
      alert("Failed to load stock history: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "StockHistory") {
    fetchStockHistory();
  }
}, [selectedOption]);

// FILTER FUNCTION
const filterByDate = (data, type, value) => {
  if (type === "all" || !value) return data;

  return data.filter(item => {
    if (!item.createdAt) return false;

    const d = item.createdAt.toDate();

    if (type === "day") {
      const filterDate = new Date(value);
      return d.toDateString() === filterDate.toDateString();
    }

    if (type === "month") {
      const [y, m] = value.split("-");
      return d.getFullYear() === +y && d.getMonth() + 1 === +m;
    }

    if (type === "year") {
      return d.getFullYear() === +value;
    }

    return true;
  });
};

// APPLY FILTER
useEffect(() => {
  const filtered = filterByDate(frameStockHistory, filterType, filterValue);
  setFilteredFrameHistory(filtered);
  console.log("Filtered data:", filtered); // Debug log
}, [frameStockHistory, filterType, filterValue]);

// RESET FILTERS
const resetFilters = () => {
  setFilterType("all");
  setFilterValue("");
};

// EXPORT TO EXCEL
const exportToExcel = () => {
  try {
    let exportData = [];

    filteredFrameHistory.forEach(stock => {
      // Handle items array safely
      const items = Array.isArray(stock.items) && stock.items.length > 0
        ? stock.items
        : [{
            modelNo: stock.modelNo || "-",
            brand: stock.brand || "-",
            colour: stock.colour || "-",
            sex: stock.sex || "-",
            qty: stock.qty || 0,
            supplyQty: stock.supplyQty || 0
          }];

      items.forEach(item => {
        exportData.push({
          "Supplier Name": stock.supplierName || "",
          "Purchase Date": item.purchaseDate || (stock.createdAt?.toDate().toLocaleDateString()) || "",
          "Model No": item.modelNo || "",
          "Brand": item.brand || "",
          "Colour": item.colour || "",
          "Sex": item.sex || "",
          "Current Available Qty": item.qty || 0,
          "Added Qty": item.supplyQty || 0,
          "Stock Added Date": stock.createdAt?.toDate().toLocaleDateString() || "",
          "Filter Applied": filterType === "all"
            ? "All Data"
            : filterType === "day"
            ? `Date: ${filterValue}`
            : filterType === "month"
            ? `Month: ${filterValue}`
            : `Year: ${filterValue}`
        });
      });
    });

    if (exportData.length === 0) {
      alert("No data to export!");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(exportData);

    // Auto column width
    ws["!cols"] = Object.keys(exportData[0]).map(key => {
      const maxLength = Math.max(
        key.length,
        ...exportData.map(row => String(row[key] || "").length)
      );
      return { wch: Math.min(maxLength + 2, 50) };
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Frame_Stock_History");

    // File name
    const date = new Date();
    const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    
    const filterStr = filterType !== "all"
      ? `_${filterType}_${filterValue.replace(/[^a-zA-Z0-9]/g, "-")}`
      : "";

    const fileName = `Frame_Stock_History${filterStr}_${dateStr}.xlsx`;
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, fileName);

    alert(`Exported ${exportData.length} records successfully!`);
  } catch (error) {
    console.error("Export error:", error);
    alert("Export failed: " + error.message);
  }
};




/* ======================= delete FUNCTION ======================= */

const handleDeleteStock = async (stockId, modelNo) => {
  const password = prompt(
    `Enter password to delete ${modelNo}:`
  );

  if (password !== "naveen000") {
    alert("Incorrect password!");
    return;
  }

  const confirmDelete = window.confirm(
    `Are you sure you want to delete ${modelNo}?`
  );

  if (!confirmDelete) return;

  try {
    await deleteDoc(doc(db, "stock", stockId));

    // REMOVE FROM LOCAL STATE
    const updatedHistory = frameStockHistory.filter(
      (item) => item.id !== stockId
    );

    setFrameStockHistory(updatedHistory);

    alert("Stock deleted successfully!");

  } catch (error) {
    console.error("Delete error:", error);
    alert("Failed to delete stock!");
  }
};
















// ADD THESE STATES
const [editingStockId, setEditingStockId] = useState(null);
const [editingQty, setEditingQty] = useState("");
const [editingModel, setEditingModel] = useState("");



// ADD THIS FUNCTION
const handleEditStock = async (stockId, modelNo, currentQty) => {
  const password = prompt("Enter password to edit stock:");

  if (password !== "naveen000") {
    alert("Incorrect password!");
    return;
  }

  const newQty = prompt(
    `Edit stock quantity for ${modelNo}`,
    currentQty
  );

  if (newQty === null) return;

  const qtyNumber = Number(newQty);

  if (isNaN(qtyNumber) || qtyNumber < 0) {
    alert("Invalid quantity!");
    return;
  }

  try {
    const stockRef = doc(db, "stock", stockId);

    // GET CURRENT STOCK DOCUMENT
    const currentStock = frameStockHistory.find(
      item => item.id === stockId
    );

    if (!currentStock) {
      alert("Stock record not found!");
      return;
    }

    // UPDATE ITEMS ARRAY
    let updatedItems = [];

    if (
      Array.isArray(currentStock.items) &&
      currentStock.items.length > 0
    ) {
      updatedItems = currentStock.items.map(item => {
        if (item.modelNo === modelNo) {
          return {
            ...item,
            qty: qtyNumber
          };
        }
        return item;
      });

      await updateDoc(stockRef, {
        items: updatedItems,
        updatedAt: new Date()
      });
    } else {
      // SINGLE ITEM STRUCTURE
      await updateDoc(stockRef, {
        qty: qtyNumber,
        updatedAt: new Date()
      });
    }

    // UPDATE LOCAL STATE
    const updatedHistory = frameStockHistory.map(stock => {
      if (stock.id === stockId) {
        if (
          Array.isArray(stock.items) &&
          stock.items.length > 0
        ) {
          return {
            ...stock,
            items: stock.items.map(item => {
              if (item.modelNo === modelNo) {
                return {
                  ...item,
                  qty: qtyNumber
                };
              }
              return item;
            })
          };
        } else {
          return {
            ...stock,
            qty: qtyNumber
          };
        }
      }
      return stock;
    });

    setFrameStockHistory(updatedHistory);

    alert("Stock updated successfully!");

  } catch (error) {
    console.error("Update error:", error);
    alert("Failed to update stock!");
  }
};

////////////////////////////////////////////////// Quick add stock /////////////////////////////////////////////////


// Quick Add Stock states
// const [quickSelectedCategory, setQuickSelectedCategory] = useState("");
// const [quickSupplierName, setQuickSupplierName] = useState("");
// const [quickPurchaseDate, setQuickPurchaseDate] = useState("");
// const [quickItems, setQuickItems] = useState([]);
// const [suppliersList, setSuppliersList] = useState([]);

// // Fetch suppliers for quick add
// useEffect(() => {
//   const fetchSuppliers = async () => {
//     try {
//       const q = query(collection(db, "suppliers"), orderBy("name"));
//       const snapshot = await getDocs(q);
//       const suppliers = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//       setSuppliersList(suppliers);
//     } catch (err) {
//       console.error("Error fetching suppliers:", err);
//     }
//   };
  
//   if (selectedOption === "quickAdd") {
//     fetchSuppliers();
//   }
// }, [selectedOption]);



// // Quick Add Stock handlers
// const handleAddQuickItemRow = () => {
//   setQuickItems([
//     ...quickItems,
//     {
      
//       modelNo: "",
//       brand: "",
//       colour: "",
//       sex: "",
//       qty: 0,

//       supplyQty: 0
//     }
//   ]);
// };

// const handleQuickItemChange = (index, field, value) => {
//   const updatedItems = [...quickItems];
//   updatedItems[index][field] = value;
//   setQuickItems(updatedItems);
// };

// const handleRemoveQuickItem = (index) => {
//   const updatedItems = quickItems.filter((_, i) => i !== index);
//   setQuickItems(updatedItems);
// };

// const handleQuickAddStock = async () => {

//   if (!quickSupplierName) {
//     alert("Select Supplier");
//     return;
//   }
  
//   if (!quickPurchaseDate) {
//     alert("Select Purchase Date");
//     return;
//   }
  
//   if (quickItems.length === 0) {
//     alert("Add at least one item");
//     return;
//   }
  
//   // Validate each item
//   let hasError = false;
  
//   if (quickSelectedCategory === "lens") {
//     for (let i = 0; i < quickItems.length; i++) {
//       const item = quickItems[i];
//       if (!item.itemCode) {
//         alert(`Item ${i + 1}: Item Code is required`);
//         hasError = true;
//         break;
//       }
//       if (!item.model) {
//         alert(`Item ${i + 1}: Model is required`);
//         hasError = true;
//         break;
//       }
//       if (item.qty <= 0) {
//         alert(`Item ${i + 1}: Quantity must be greater than 0`);
//         hasError = true;
//         break;
//       }
//       if (item.supplyQty <= 0) {
//         alert(`Item ${i + 1}: Supply Quantity must be greater than 0`);
//         hasError = true;
//         break;
//       }
//     }
//   } else if (quickSelectedCategory === "frame") {
//     for (let i = 0; i < quickItems.length; i++) {
//       const item = quickItems[i];
//       if (!item.itemCode) {
//         alert(`Item ${i + 1}: Item Code is required`);
//         hasError = true;
//         break;
//       }
//       if (!item.modelNo) {
//         alert(`Item ${i + 1}: Model No is required`);
//         hasError = true;
//         break;
//       }
//       if (!item.brand) {
//         alert(`Item ${i + 1}: Brand is required`);
//         hasError = true;
//         break;
//       }
//       if (item.qty <= 0) {
//         alert(`Item ${i + 1}: Quantity must be greater than 0`);
//         hasError = true;
//         break;
//       }
//       if (item.supplyQty <= 0) {
//         alert(`Item ${i + 1}: Supply Quantity must be greater than 0`);
//         hasError = true;
//         break;
//       }
//     }
//   }
  
//   if (hasError) return;
  
//   try {
//     // Generate a quick purchase order number
//     const quickPONo = `QUICK-${Date.now()}`;
    
//     await addDoc(collection(db, "stock"), {
//       purchaseOrderNo: quickPONo,
//       supplierName: quickSupplierName,
//       category: quickSelectedCategory,
//       purchaseDate: quickPurchaseDate,
//       items: quickItems,
//       isQuickAdd: true,
//       createdAt: serverTimestamp()
//     });
    
//     alert("Stock added successfully!");
//     handleClearQuickForm();
//   } catch (err) {
//     console.error(err);
//     alert("Failed to add stock.");
//   }
// };

// const handleClearQuickForm = () => {
//   setQuickSelectedCategory("");
//   setQuickSupplierName("");
//   setQuickPurchaseDate("");
//   setQuickItems([]);
// };


/* ================= STATES ================= */

const [quickSelectedCategory, setQuickSelectedCategory] =
  useState("frame");

const [quickSupplierName, setQuickSupplierName] =
  useState("");

const [quickPurchaseDate, setQuickPurchaseDate] =
  useState("");

const [quickItems, setQuickItems] = useState([]);

const [suppliersList, setSuppliersList] = useState([]);

/* ================= FETCH SUPPLIERS ================= */

useEffect(() => {
  const fetchSuppliers = async () => {
    try {
      const q = query(
        collection(db, "suppliers"),
        orderBy("name")
      );

      const snapshot = await getDocs(q);

      const suppliers = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setSuppliersList(suppliers);
    } catch (err) {
      console.error(
        "Error fetching suppliers:",
        err
      );
    }
  };

  if (selectedOption === "quickAdd") {
    fetchSuppliers();
  }
}, [selectedOption]);

/* ================= ADD ITEM ROW ================= */

const handleAddQuickItemRow = () => {
  setQuickItems([
    ...quickItems,
    {
    
      modelNo: "",
      brand: "",
      colour: "",
      sex: "",
      qty: 0,
      supplyQty: 0,
    
      sellingPrice: 0,
    },
  ]);
};

/* ================= HANDLE ITEM CHANGE ================= */

const handleQuickItemChange = (
  index,
  field,
  value
) => {
  const updatedItems = [...quickItems];

  updatedItems[index][field] = value;

  setQuickItems(updatedItems);
};

/* ================= REMOVE ITEM ================= */

const handleRemoveQuickItem = (index) => {
  const updatedItems = quickItems.filter(
    (_, i) => i !== index
  );

  setQuickItems(updatedItems);
};

/* ================= ADD STOCK ================= */

const handleQuickAddStock = async () => {
  if (!quickSupplierName) {
    alert("Select Supplier");
    return;
  }

  if (!quickPurchaseDate) {
    alert("Select Purchase Date");
    return;
  }

  if (quickItems.length === 0) {
    alert("Add at least one item");
    return;
  }

  let hasError = false;

  for (let i = 0; i < quickItems.length; i++) {
    const item = quickItems[i];



    if (!item.modelNo) {
      alert(
        `Item ${i + 1}: Model No is required`
      );
      hasError = true;
      break;
    }

    if (!item.brand) {
      alert(
        `Item ${i + 1}: Brand is required`
      );
      hasError = true;
      break;
    }

    if (item.qty <= 0) {
      alert(
        `Item ${i + 1}: Quantity must be greater than 0`
      );
      hasError = true;
      break;
    }

    if (item.supplyQty <= 0) {
      alert(
        `Item ${i + 1}: Supply Quantity must be greater than 0`
      );
      hasError = true;
      break;
    }



    if (item.sellingPrice <= 0) {
      alert(
        `Item ${i + 1}: Selling Price must be greater than 0`
      );
      hasError = true;
      break;
    }
  }

  if (hasError) return;

  try {
    const quickPONo = `QUICK-${Date.now()}`;

    await addDoc(collection(db, "stock"), {
      purchaseOrderNo: quickPONo,
      supplierName: quickSupplierName,
      category: quickSelectedCategory,
      purchaseDate: quickPurchaseDate,
      items: quickItems,
      isQuickAdd: true,
      createdAt: serverTimestamp(),
    });

    alert("Stock added successfully!");

    handleClearQuickForm();
  } catch (err) {
    console.error(err);

    alert("Failed to add stock.");
  }
};

/* ================= CLEAR FORM ================= */

const handleClearQuickForm = () => {
  setQuickSelectedCategory("frame");
  setQuickSupplierName("");
  setQuickPurchaseDate("");
  setQuickItems([]);
};















/////////////////////////////////////////////////
// CREATE INVOICE
/////////////////////////////////////////////////

// State for invoice number management
const [currentInvoiceNumber, setCurrentInvoiceNumber] = useState('');
const [showSuccess, setShowSuccess] = useState(false);
const [isLoading, setIsLoading] = useState(false);
const [frameSearchTerm, setFrameSearchTerm] = useState('');
const [frameSuggestions, setFrameSuggestions] = useState([]);
const [showFrameSuggestions, setShowFrameSuggestions] = useState(false);
const [availableFrames, setAvailableFrames] = useState([]);
const [lensOptions, setLensOptions] = useState([]);

// Form data state
// ================= UPDATE FORM DATA STATE =================

const [formData, setFormData] = useState({
  frameModel: '',
  brand: '',
  colour: '',
  selectedFrameId: '',
  selectedFrameItemIndex: -1,
  frameQty: 0,
  lensModel: '',
  selectedLensId: '',
  lensPrice: 0,
  framePrice: 0,

  // ADD THESE
  sellingPrice: 0,
  discount: 0,
  totalAmount: 0,

  customerName: '',
  customerPhone: ''
});


// ================= AUTO CALCULATE TOTAL =================

useEffect(() => {
  const selling =
    parseFloat(formData.sellingPrice) || 0;

  const discount =
    parseFloat(formData.discount) || 0;

  const total = selling - discount;

  setFormData((prev) => ({
    ...prev,
    totalAmount: total >= 0 ? total : 0,
  }));
}, [formData.sellingPrice, formData.discount]);




// Errors state
const [errors, setErrors] = useState({});

// Calculate total amount
const totalAmount = (parseFloat(formData.sellingPrice) || 0) - (parseFloat(formData.discount) || 0);

// Function to generate next invoice number
const generateNextInvoiceNumber = async () => {
  try {
    const invoicesRef = collection(db, 'inventory_invoices');
    const q = query(invoicesRef, orderBy('invoiceNumber', 'desc'), limit(1));
    const querySnapshot = await getDocs(q);
    
    let lastNumber = 0;
    
    if (!querySnapshot.empty) {
      const lastInvoice = querySnapshot.docs[0].data();
      const lastInvoiceNum = lastInvoice.invoiceNumber;
      const match = lastInvoiceNum.match(/INV-(\d+)/);
      if (match) {
        lastNumber = parseInt(match[1]);
      }
    }
    
    const nextNumber = lastNumber + 1;
    const formattedNumber = `INV-${nextNumber.toString().padStart(3, '0')}`;
    setCurrentInvoiceNumber(formattedNumber);
    return formattedNumber;
  } catch (error) {
    console.error('Error generating invoice number:', error);
    const fallbackNumber = `INV-${Date.now().toString().slice(-3)}`;
    setCurrentInvoiceNumber(fallbackNumber);
    return fallbackNumber;
  }
};

// Fetch frames data - GROUPED BY MODEL NUMBER WITH SUM OF QTYS
const fetchFramesData = async () => {
  try {
    const q = query(collection(db, "stock"));
    const querySnapshot = await getDocs(q);
    const framesMap = new Map(); // Use Map to group by model number

    querySnapshot.forEach(docSnap => {
      const data = docSnap.data();
      
      // Skip lens documents
      if (data.type === 'lens' || data.category === 'lens') return;
      
      if (Array.isArray(data.items) && data.items.length > 0) {
        data.items.forEach((item, index) => {
          const modelNo = item.modelNo || data.modelNo;
          const itemQty = item.qty || 0;
          
          if (framesMap.has(modelNo)) {
            // Add to existing entry - SUM THE QUANTITY
            const existing = framesMap.get(modelNo);
            existing.totalQty += itemQty;
            // Store the document references for deduction
            existing.stockEntries.push({
              docId: docSnap.id,
              itemIndex: index,
              qty: itemQty,
              item: item
            });
          } else {
            // New entry
            framesMap.set(modelNo, {
  modelNo: modelNo,
  brand: item.brand || data.brand,
  colour: item.colour || data.colour,
  sex: item.sex || data.sex,

  // CHANGE THIS
  sellingPrice:
    item.sellingPrice ||
    data.sellingPrice ||
    0,

  totalQty: itemQty,

  stockEntries: [
    {
      docId: docSnap.id,
      itemIndex: index,
      qty: itemQty,
      item: item,
    },
  ],
});
          }
        });
      } else if (data.modelNo && (data.quantity > 0 || data.qty > 0)) {
        const modelNo = data.modelNo;
        const itemQty = data.quantity || data.qty || 0;
        
        if (framesMap.has(modelNo)) {
          const existing = framesMap.get(modelNo);
          existing.totalQty += itemQty;
          existing.stockEntries.push({
            docId: docSnap.id,
            itemIndex: -1,
            qty: itemQty,
            item: data
          });
        } else {
          framesMap.set(modelNo, {
            modelNo: modelNo,
            brand: data.brand,
            colour: data.colour,
            sex: data.sex,
            price: data.price || 0,
            totalQty: itemQty,
            stockEntries: [{
              docId: docSnap.id,
              itemIndex: -1,
              qty: itemQty,
              item: data
            }]
          });
        }
      }
    });

    // Convert Map to array and filter out zero stock
    const framesList = Array.from(framesMap.values()).filter(frame => frame.totalQty > 0);
    
    setAvailableFrames(framesList);
    console.log('Grouped frames with total stock:', framesList);
  } catch (err) {
    console.error("Error loading frames:", err);
  }
};

// Handle frame search with suggestions showing TOTAL available stock
const handleFrameSearch = (text) => {
  setFrameSearchTerm(text);
  setFormData(prev => ({ ...prev, frameModel: text }));

  if (text.length < 1) {
    setShowFrameSuggestions(false);
    setFrameSuggestions([]);
    return;
  }

  const filtered = availableFrames.filter(frame => 
    (frame.modelNo?.toLowerCase().includes(text.toLowerCase()) ||
     frame.brand?.toLowerCase().includes(text.toLowerCase()) ||
     frame.colour?.toLowerCase().includes(text.toLowerCase())) && 
    frame.totalQty > 0
  );
  
  setFrameSuggestions(filtered);
  setShowFrameSuggestions(true);
};

// Select frame with stock validation using TOTAL stock
const selectFrame = (frame) => {
  if (frame.totalQty <= 0) {
    alert(
      `Out of stock! Total available: ${frame.totalQty}`
    );
    return;
  }

  setFrameSearchTerm(frame.modelNo);

  setShowFrameSuggestions(false);

  setFormData((prev) => ({
    ...prev,

    frameModel: frame.modelNo,
    brand: frame.brand || "",
    colour: frame.colour || "",

    selectedFrameId:
      frame.stockEntries[0]?.docId || "",

    selectedFrameItemIndex:
      frame.stockEntries[0]?.itemIndex || -1,

    frameQty: frame.totalQty,

    // AUTO FILL SELLING PRICE
    sellingPrice:
      frame.sellingPrice || 0,
  }));
};



// Validate if frame is still available before saving
const validateFrameAvailability = async () => {
  if (!formData.frameModel) return true;
  
  try {
    // Find the frame in availableFrames by model number
    const frame = availableFrames.find(f => f.modelNo === formData.frameModel);
    
    if (!frame || frame.totalQty <= 0) {
      alert(`❌ Frame "${formData.frameModel}" is no longer available!`);
      return false;
    }
    
    // Update displayed quantity
    setFormData(prev => ({ ...prev, frameQty: frame.totalQty }));
    return true;
  } catch (error) {
    console.error('Error validating frame:', error);
    return false;
  }
};

// Handle stock deduction from the appropriate entry
// Handle stock deduction from the appropriate entry
const deductFrameStock = async (frameModel) => {
  const frame = availableFrames.find(f => f.modelNo === frameModel);
  
  if (!frame || frame.totalQty <= 0) {
    throw new Error(`Frame "${frameModel}" is out of stock`);
  }
  
  // Find the first entry with stock > 0
  const entryToDeduct = frame.stockEntries.find(entry => entry.qty > 0);
  
  if (!entryToDeduct) {
    throw new Error(`No stock available for frame "${frameModel}"`);
  }
  
  const frameRef = doc(db, 'stock', entryToDeduct.docId);
  const frameDoc = await getDoc(frameRef);
  
  if (!frameDoc.exists()) {
    throw new Error(`Frame document not found`);
  }
  
  const frameData = frameDoc.data();
  let updatedItems = [];
  let newQty = 0;
  let currentQty = 0; // ADD THIS LINE - declare currentQty here
  
  if (frameData.items && Array.isArray(frameData.items) && entryToDeduct.itemIndex !== -1) {
    // Handle items array
    currentQty = frameData.items[entryToDeduct.itemIndex]?.qty || 0;
    newQty = currentQty - 1;
    
    updatedItems = [...frameData.items];
    updatedItems[entryToDeduct.itemIndex] = {
      ...updatedItems[entryToDeduct.itemIndex],
      qty: newQty
    };
    
    await updateDoc(frameRef, { items: updatedItems });
  } else if (frameData.quantity !== undefined) {
    // Handle single quantity field
    currentQty = frameData.quantity;
    newQty = currentQty - 1;
    await updateDoc(frameRef, { quantity: newQty });
  } else if (frameData.qty !== undefined) {
    currentQty = frameData.qty;
    newQty = currentQty - 1;
    await updateDoc(frameRef, { qty: newQty });
  }
  
  // Update the local availableFrames state
  entryToDeduct.qty = newQty;
  frame.totalQty -= 1;
  
  // Remove from availableFrames if totalQty becomes 0
  if (frame.totalQty === 0) {
    setAvailableFrames(prev => prev.filter(f => f.modelNo !== frameModel));
  } else {
    setAvailableFrames(prev => [...prev]);
  }
  
  return { success: true, remainingStock: newQty };
};

// Handle save order with stock deduction
// ================= UPDATE HANDLE SAVE =================

const handleSaveOrderWithNumber = async (
  invoiceNumber
) => {
  const isFrameAvailable =
    await validateFrameAvailability();

  if (!isFrameAvailable) {
    setIsLoading(false);
    return;
  }

  let deductionResult = null;

  if (formData.frameModel) {
    try {
      deductionResult = await deductFrameStock(
        formData.frameModel
      );
    } catch (error) {
      alert(error.message);
      setIsLoading(false);
      return;
    }
  }

  const invoiceData = {
    invoiceNumber: invoiceNumber,

    customerName:
      formData.customerName ||
      "Walk-in Customer",

    customerPhone:
      formData.customerPhone || "",

    products: {
      frame: {
        model: formData.frameModel,
        brand: formData.brand,
        colour: formData.colour,

        // SAVE SELLING PRICE
        sellingPrice:
          formData.sellingPrice || 0,
      },
    },

    // SAVE THESE
    discount:
      parseFloat(formData.discount) || 0,

    totalAmount:
      parseFloat(formData.totalAmount) || 0,

    createdAt: new Date().toISOString(),

    status: "completed",
  };

  await addDoc(
    collection(db, "inventory_invoices"),
    invoiceData
  );

  if (formData.frameModel) {
    await addDoc(collection(db, "stock_out"), {
      productType: "frame",

      productModel: formData.frameModel,

      brand: formData.brand,

      colour: formData.colour,

      quantity: 1,

      invoiceNumber: invoiceNumber,

      sellingPrice:
        parseFloat(formData.sellingPrice) || 0,

      discount:
        parseFloat(formData.discount) || 0,

      totalAmount:
        parseFloat(formData.totalAmount) || 0,

      date: new Date(),

      type: "sale",

      remainingStock:
        deductionResult?.remainingStock || 0,
    });
  }

  setShowSuccess(true);

  setTimeout(() => setShowSuccess(false), 3000);

  handleResetForm();

  await fetchFramesData();

  await generateNextInvoiceNumber();

  console.log(
    `✅ Invoice ${invoiceNumber} created successfully`
  );
};








// Main handleSaveOrder function
const handleSaveOrder = async () => {
  setIsLoading(true);
  
  try {
    // Validate frame is selected
    if (!formData.frameModel) {
      alert('❌ Please select a frame from the suggestions!');
      setIsLoading(false);
      return;
    }
    
    // Validate frame still has stock
    const isAvailable = await validateFrameAvailability();
    if (!isAvailable) {
      setIsLoading(false);
      return;
    }
    
    const invoiceNumber = await generateNextInvoiceNumber();
    
    // Verify invoice number is unique
    const invoiceCheckQuery = query(
      collection(db, 'inventory_invoices'),
      where('invoiceNumber', '==', invoiceNumber)
    );
    const existingInvoice = await getDocs(invoiceCheckQuery);
    
    if (!existingInvoice.empty) {
      console.warn('Duplicate invoice number detected, regenerating...');
      const newInvoiceNumber = await generateNextInvoiceNumber();
      await handleSaveOrderWithNumber(newInvoiceNumber);
    } else {
      await handleSaveOrderWithNumber(invoiceNumber);
    }
    
  } catch (error) {
    console.error('Error saving order:', error);
    alert('Error saving order: ' + error.message);
  } finally {
    setIsLoading(false);
  }
};

// Reset form
const handleResetForm = () => {
  setFormData({
    frameModel: '',
    brand: '',
    colour: '',
    selectedFrameId: '',
    selectedFrameItemIndex: -1,
    frameQty: 0,
    lensModel: '',
    selectedLensId: '',
    lensPrice: 0,
    framePrice: 0,

    sellingPrice: 0,
    discount: 0,
    totalAmount: 0,

    customerName: '',
    customerPhone: ''
  });

  setFrameSearchTerm('');

  setErrors({});

  setShowFrameSuggestions(false);

  setFrameSuggestions([]);
};




// Handle input changes
const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

// Initialize
useEffect(() => {
  const init = async () => {
    await fetchFramesData();
    await generateNextInvoiceNumber();
  };
  init();
}, []);






// Add this CSS for suggestions dropdown (add to your CSS file or styled-components)
const styles = `
  .suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  .suggestion-item {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
  }
  
  .suggestion-item:hover {
    background-color: #f5f5f5;
  }
  
  .suggestion-details {
    font-size: 12px;
    color: #666;
    margin-top: 4px;
  }
  
  .stock-badge {
    background: #4CAF50;
    color: white;
    padding: 2px 6px;
    border-radius: 3px;
    margin-left: 8px;
    font-size: 10px;
  }
  
  .readonly-field {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
  
  .toast-notification {
    position: fixed;
    top: 20px;
    right: 20px;
    background: #4CAF50;
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    z-index: 2000;
    animation: slideIn 0.3s ease;
  }
  
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

// Inject styles (add this once in your component or in a CSS file)
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}













//////////////////////////////////////////// view stock - out/////////////////////////////////////////////////////

// Add state for stock-out data
const [stockOutRecords, setStockOutRecords] = useState([]);
const [filteredStockOut, setFilteredStockOut] = useState([]);
const [stockOutSearchTerm, setStockOutSearchTerm] = useState('');
const [stockOutFilterType, setStockOutFilterType] = useState('all');
const [stockOutDateRange, setStockOutDateRange] = useState({
  start: '',
  end: ''
});
const [isLoadingStockOut, setIsLoadingStockOut] = useState(false);

// Fetch stock-out history
const fetchStockOutHistory = async () => {
  try {
    setIsLoadingStockOut(true);
    const stockOutQuery = query(
      collection(db, 'stock_out'),
      orderBy('date', 'desc')
    );
    const stockOutSnapshot = await getDocs(stockOutQuery);
    // const records = stockOutSnapshot.docs.map(doc => ({ 
    //   id: doc.id, 
    //   ...doc.data(),
    //   dateFormatted: new Date(doc.data().date).toLocaleDateString(),
    //   timeFormatted: new Date(doc.data().date).toLocaleTimeString()
    // }));
    const records = stockOutSnapshot.docs.map((doc) => {
  const data = doc.data();

  let jsDate;

  if (data.date?.toDate) {
    jsDate = data.date.toDate(); // Firestore Timestamp
  } else {
    jsDate = new Date(data.date); // normal date/string
  }

  return {
    id: doc.id,
    ...data,
    dateFormatted: jsDate.toLocaleDateString(),
    timeFormatted: jsDate.toLocaleTimeString()
  };
});



    
    setStockOutRecords(records);
    setFilteredStockOut(records);
    setIsLoadingStockOut(false);
  } catch (error) {
    console.error('Error fetching stock-out history:', error);
    setIsLoadingStockOut(false);
    alert('Error fetching stock-out history: ' + error.message);
  }
};

// Filter stock-out records
const filterStockOut = () => {
  let filtered = [...stockOutRecords];
  
  // Filter by search term
  if (stockOutSearchTerm) {
    const searchLower = stockOutSearchTerm.toLowerCase();
    filtered = filtered.filter(record => 
      record.productModel?.toLowerCase().includes(searchLower) ||
      record.brand?.toLowerCase().includes(searchLower) ||
      record.customerName?.toLowerCase().includes(searchLower) ||
      record.invoiceNumber?.toLowerCase().includes(searchLower) ||
      record.colour?.toLowerCase().includes(searchLower)
    );
  }
  
  // Filter by product type
  if (stockOutFilterType !== 'all') {
    filtered = filtered.filter(record => record.productType === stockOutFilterType);
  }
  
  // Filter by date range
  if (stockOutDateRange.start) {
    const startDate = new Date(stockOutDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(record => new Date(record.date) >= startDate);
  }
  
  if (stockOutDateRange.end) {
    const endDate = new Date(stockOutDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(record => new Date(record.date) <= endDate);
  }
  
  setFilteredStockOut(filtered);
};

// Generate stock-out report PDF
const generateStockOutReportPDF = async () => {
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const primaryColor = [41, 128, 185];

  // Header
  pdf.setFillColor(...primaryColor);
  pdf.rect(0, 0, pageWidth, 25, "F");

  pdf.setFontSize(20);
  pdf.setTextColor(255, 255, 255);
  pdf.text("STOCK OUT HISTORY REPORT", pageWidth / 2, 10, { align: "center" });

  pdf.setFontSize(10);
  pdf.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 18, { align: "center" });

  let y = 35;

  // Summary stats
  const totalItems = filteredStockOut.reduce((sum, record) => sum + (record.quantity || 0), 0);
  const totalValue = filteredStockOut.reduce((sum, record) => sum + ((record.price || 0) * (record.quantity || 0)), 0);
  const frameCount = filteredStockOut.filter(r => r.productType === 'frame').length;
  const lensCount = filteredStockOut.filter(r => r.productType === 'lens').length;

  pdf.setFontSize(12);
  pdf.setTextColor(...primaryColor);
  pdf.text("SUMMARY", 10, y);

  y += 7;
  pdf.setFontSize(10);
  pdf.setTextColor(0, 0, 0);
  pdf.text(`Total Items Sold: ${totalItems}`, 10, y);
  pdf.text(`Total Value: Rs. ${totalValue.toFixed(2)}`, 80, y);
  pdf.text(`Frames: ${frameCount}`, 150, y);
  pdf.text(`Lenses: ${lensCount}`, 200, y);

  y += 15;

  // Table headers
  pdf.setFillColor(...primaryColor);
  pdf.rect(10, y, 20, 8, 'F');
  pdf.rect(30, y, 40, 8, 'F');
  pdf.rect(70, y, 30, 8, 'F');
  pdf.rect(100, y, 40, 8, 'F');
  pdf.rect(140, y, 30, 8, 'F');
  pdf.rect(170, y, 20, 8, 'F');
  pdf.rect(190, y, 30, 8, 'F');

  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(9);
  pdf.text("Type", 12, y + 5);
  pdf.text("Model", 32, y + 5);
  pdf.text("Customer", 72, y + 5);
  pdf.text("Invoice No", 102, y + 5);
  pdf.text("Date", 142, y + 5);
  pdf.text("Qty", 172, y + 5);
  pdf.text("Price", 192, y + 5);

  y += 8;

  // Table rows
  pdf.setTextColor(0, 0, 0);
  for (let record of filteredStockOut.slice(0, 20)) { // Limit to 20 records per page
    if (y > 250) {
      pdf.addPage();
      y = 20;
    }
    
    pdf.rect(10, y, 20, 7);
    pdf.rect(30, y, 40, 7);
    pdf.rect(70, y, 30, 7);
    pdf.rect(100, y, 40, 7);
    pdf.rect(140, y, 30, 7);
    pdf.rect(170, y, 20, 7);
    pdf.rect(190, y, 30, 7);
    
    pdf.text(record.productType || 'N/A', 12, y + 5);
    pdf.text(record.productModel || 'N/A', 32, y + 5);
    pdf.text((record.customerName || 'N/A').substring(0, 15), 72, y + 5);
    pdf.text(record.invoiceNumber || 'N/A', 102, y + 5);
    pdf.text(record.dateFormatted || 'N/A', 142, y + 5);
    pdf.text(record.quantity?.toString() || '0', 172, y + 5);
    pdf.text(`Rs. ${(record.price || 0).toFixed(2)}`, 192, y + 5);
    
    y += 7;
  }

  pdf.save(`STOCK_OUT_REPORT_${Date.now()}.pdf`);
};

// Calculate summary statistics
const getStockOutSummary = () => {
  const totalItems = filteredStockOut.reduce((sum, record) => sum + (record.quantity || 0), 0);
  const totalValue = filteredStockOut.reduce((sum, record) => sum + ((record.price || 0) * (record.quantity || 0)), 0);
  const frameTotal = filteredStockOut.filter(r => r.productType === 'frame').reduce((sum, r) => sum + (r.quantity || 0), 0);
  const lensTotal = filteredStockOut.filter(r => r.productType === 'lens').reduce((sum, r) => sum + (r.quantity || 0), 0);
  
  return { totalItems, totalValue, frameTotal, lensTotal };
};

// Fetch stock-out on component mount
useEffect(() => {
  if (selectedOption === "viewStockOut") {
    fetchStockOutHistory();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  filterStockOut();
}, [stockOutSearchTerm, stockOutFilterType, stockOutDateRange.start, stockOutDateRange.end, stockOutRecords]);

// Reset filters
const resetStockOutFilters = () => {
  setStockOutSearchTerm('');
  setStockOutFilterType('all');
  setStockOutDateRange({ start: '', end: '' });
  setFilteredStockOut(stockOutRecords);
};

// Delete stock-out record (admin only)
const deleteStockOutRecord = async (recordId) => {
  if (window.confirm('Are you sure you want to delete this record?')) {
    try {
      await deleteDoc(doc(db, 'stock_out', recordId));
      await fetchStockOutHistory();
      alert('Record deleted successfully');
    } catch (error) {
      console.error('Error deleting record:', error);
      alert('Error deleting record: ' + error.message);
    }
  }
};






  
 






//////////////////////////////////////////////   dashboard     /////////////////////////////////////////////////////////////////////////

// Add state for dashboard data
const [dashboardStats, setDashboardStats] = useState({
  totalRevenue: 0,
  totalInvoices: 0,
  totalPatients: 0,
  pendingBalance: 0,
  monthlyRevenue: [],
  topProducts: [],
  recentInvoices: [],
  paymentMethods: [],
  dailySales: [],
  framesSold: 0,
  lensesSold: 0,
  averageInvoiceValue: 0
});
const [isLoadingDashboard, setIsLoadingDashboard] = useState(false);
const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

// Fetch dashboard data
const fetchDashboardData = async () => {
  try {
    setIsLoadingDashboard(true);
    
    // Fetch all invoices
    const invoicesQuery = query(collection(db, 'inventory_invoices'));
    const invoicesSnapshot = await getDocs(invoicesQuery);
    const invoices = [];
    
    for (const doc of invoicesSnapshot.docs) {
      const data = doc.data();
      
      // Fetch balance payments for this invoice
      const balanceQuery = query(
        collection(db, 'balance_invoices'),
        where('originalInvoiceNumber', '==', data.invoiceNumber)
      );
      const balanceSnapshot = await getDocs(balanceQuery);
      let totalBalancePaid = 0;
      
      balanceSnapshot.forEach(balanceDoc => {
        totalBalancePaid += balanceDoc.data().paidAmount || 0;
      });
      
      invoices.push({
        ...data,
        id: doc.id,
        totalPaid: (data.financial?.advancePayment || 0) + totalBalancePaid,
        totalBalancePaid: totalBalancePaid,
        createdAt: data.createdAt ? new Date(data.createdAt) : new Date()
      });
    }
    
    // Calculate total revenue (all paid amounts)
    const totalRevenue = invoices.reduce((sum, inv) => sum + (inv.totalPaid || 0), 0);
    
    // Calculate pending balance
    const pendingBalance = invoices.reduce((sum, inv) => sum + (inv.financial?.balanceDue || 0), 0);
    
    // Get unique patients
    const uniquePatients = new Map();
    invoices.forEach(inv => {
      if (inv.customer && inv.customer.firstName) {
        const key = `${inv.customer.firstName}_${inv.customer.lastName}_${inv.customer.tpNo}`;
        if (!uniquePatients.has(key)) {
          uniquePatients.set(key, inv.customer);
        }
      }
    });
    
    // Calculate monthly revenue for current year
    const monthlyRevenue = Array(12).fill(0);
    invoices.forEach(inv => {
      const year = inv.createdAt.getFullYear();
      const month = inv.createdAt.getMonth();
      if (year === selectedYear) {
        monthlyRevenue[month] += inv.totalPaid || 0;
      }
    });
    
    // Calculate daily sales for current month
    const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
    const dailySales = Array(daysInMonth).fill(0);
    invoices.forEach(inv => {
      const year = inv.createdAt.getFullYear();
      const month = inv.createdAt.getMonth() + 1;
      const day = inv.createdAt.getDate();
      if (year === selectedYear && month === selectedMonth) {
        dailySales[day - 1] += inv.totalPaid || 0;
      }
    });
    
    // Calculate top products
    const productSales = new Map();
    invoices.forEach(inv => {
      const frame = inv.products?.frameModel;
      const lens = inv.products?.lensModel;
      
      if (frame) {
        productSales.set(frame, (productSales.get(frame) || 0) + 1);
      }
      if (lens) {
        productSales.set(lens, (productSales.get(lens) || 0) + 1);
      }
    });
    
    const topProducts = Array.from(productSales.entries())
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 5);
    
    // Calculate payment methods distribution
    const paymentMethods = new Map();
    invoices.forEach(inv => {
      const method = inv.financial?.paymentMethod || 'Cash';
      paymentMethods.set(method, (paymentMethods.get(method) || 0) + (inv.totalPaid || 0));
    });
    
    const paymentMethodsData = Array.from(paymentMethods.entries()).map(([name, value]) => ({
      name,
      value
    }));
    
    // Calculate frames and lenses sold
    let framesSold = 0;
    let lensesSold = 0;
    invoices.forEach(inv => {
      if (inv.products?.frameModel) framesSold++;
      if (inv.products?.lensModel) lensesSold++;
    });
    
    // Get recent invoices
    const recentInvoices = invoices
      .sort((a, b) => b.createdAt - a.createdAt)
      .slice(0, 5)
      .map(inv => ({
        invoiceNumber: inv.invoiceNumber,
        customerName: inv.customer?.fullName || 'N/A',
        totalAmount: inv.financial?.totalAmount || 0,
        paidAmount: inv.totalPaid || 0,
        balanceDue: inv.financial?.balanceDue || 0,
        date: inv.createdAt
      }));
    
    setDashboardStats({
      totalRevenue,
      totalInvoices: invoices.length,
      totalPatients: uniquePatients.size,
      pendingBalance,
      monthlyRevenue,
      topProducts,
      recentInvoices,
      paymentMethods: paymentMethodsData,
      dailySales,
      framesSold,
      lensesSold,
      averageInvoiceValue: invoices.length > 0 ? totalRevenue / invoices.length : 0
    });
    
    setIsLoadingDashboard(false);
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    setIsLoadingDashboard(false);
  }
};

// Chart configurations
const revenueChartData = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  datasets: [
    {
      label: 'Monthly Revenue (Rs.)',
      data: dashboardStats.monthlyRevenue,
      backgroundColor: 'rgba(41, 128, 185, 0.8)',
      borderColor: 'rgba(41, 128, 185, 1)',
      borderWidth: 2,
      borderRadius: 5,
    },
  ],
};

const revenueChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: `Monthly Revenue - ${selectedYear}`,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: (value) => `Rs. ${value.toLocaleString()}`,
      },
    },
  },
};

const paymentMethodChartData = {
  labels: dashboardStats.paymentMethods.map(m => m.name),
  datasets: [
    {
      data: dashboardStats.paymentMethods.map(m => m.value),
      backgroundColor: [
        '#4CAF50',
        '#2196F3',
        '#FF9800',
        '#9C27B0',
        '#F44336',
      ],
      borderWidth: 0,
    },
  ],
};

const paymentMethodOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
    },
    title: {
      display: true,
      text: 'Payment Methods Distribution',
    },
  },
};

const dailySalesChartData = {
  labels: Array.from({ length: dashboardStats.dailySales.length }, (_, i) => i + 1),
  datasets: [
    {
      label: `Daily Sales - ${selectedMonth}/${selectedYear}`,
      data: dashboardStats.dailySales,
      backgroundColor: 'rgba(76, 175, 80, 0.6)',
      borderColor: 'rgba(76, 175, 80, 1)',
      borderWidth: 1,
      fill: true,
    },
  ],
};

const dailySalesOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: `Daily Sales Performance`,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: (value) => `Rs. ${value.toLocaleString()}`,
      },
    },
  },
};

// Fetch data on component mount and when year/month changes
useEffect(() => {
  if (selectedOption === "dashboard") {
    fetchDashboardData();
  }
}, [selectedOption, selectedYear, selectedMonth]);

// Format currency
const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'LKR',
    minimumFractionDigits: 2
  }).format(amount);
};

////////////////////////////////// view all bills ////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////
// VIEW ALL INVOICES
/////////////////////////////////////////////////

const [allInvoices, setAllInvoices] = useState([]);
const [loadingInvoices, setLoadingInvoices] = useState(false);
const [selectedInvoice, setSelectedInvoice] = useState(null);
const [showInvoiceModal, setShowInvoiceModal] = useState(false);

// FETCH ALL INVOICES
const fetchAllInvoices = async () => {
  setLoadingInvoices(true);

  try {
    const q = query(
      collection(db, "inventory_invoices"),
      orderBy("createdAt", "desc")
    );

    const snapshot = await getDocs(q);

    const invoices = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setAllInvoices(invoices);
  } catch (error) {
    console.error("Error fetching invoices:", error);
    alert("Failed to load invoices");
  } finally {
    setLoadingInvoices(false);
  }
};

// VIEW INVOICE
const handleViewInvoice = (invoice) => {
  setSelectedInvoice(invoice);
  setShowInvoiceModal(true);
};

// DELETE INVOICE + RETURN STOCK
const handleDeleteInvoice = async (invoice) => {
  try {
    const password = prompt(
      "Enter Password To Delete Invoice & Return Stock:"
    );

    if (password !== "naveen000") {
      alert("❌ Wrong Password");
      return;
    }

    const confirmDelete = window.confirm(
      `Are you sure you want to delete invoice ${invoice.invoiceNumber}?`
    );

    if (!confirmDelete) return;

    // FRAME MODEL
    const frameModel = invoice?.products?.frame?.model;

    if (frameModel) {
      // FIND STOCK DOCUMENTS
      const stockSnapshot = await getDocs(collection(db, "stock"));

      let stockUpdated = false;

      for (const stockDoc of stockSnapshot.docs) {
        const stockData = stockDoc.data();

        if (Array.isArray(stockData.items)) {
          const updatedItems = [...stockData.items];

          for (let i = 0; i < updatedItems.length; i++) {
            const item = updatedItems[i];

            if (item.modelNo === frameModel) {
              updatedItems[i] = {
                ...item,
                qty: (item.qty || 0) + 1,
              };

              await updateDoc(doc(db, "stock", stockDoc.id), {
                items: updatedItems,
              });

              stockUpdated = true;
              break;
            }
          }
        }

        if (stockUpdated) break;
      }
    }

    // DELETE INVOICE
    await deleteDoc(doc(db, "inventory_invoices", invoice.id));

    // OPTIONAL DELETE STOCK OUT RECORD
    const stockOutQuery = query(
      collection(db, "stock_out"),
      where("invoiceNumber", "==", invoice.invoiceNumber)
    );

    const stockOutSnapshot = await getDocs(stockOutQuery);

    for (const stockOutDoc of stockOutSnapshot.docs) {
      await deleteDoc(doc(db, "stock_out", stockOutDoc.id));
    }

    alert("✅ Bill deleted & stock returned successfully");

    fetchAllInvoices();
    fetchFramesData();

  } catch (error) {
    console.error("Delete Error:", error);
    alert("Failed to delete invoice");
  }
};

// LOAD INVOICES
useEffect(() => {
  if (selectedOption === "viewAllInvoice") {
    fetchAllInvoices();
  }
}, [selectedOption]);






  return (
    <>
      {/* 🔵 TOP NAVIGATION BAR */}
<nav className="top-nav">
  <div className="logo">Powered By GLAXMORE IT</div>

  <ul className="nav-links">

    {/* Normal Tabs */}
    <li
      className={selectedOption === "dashboard" ? "active" : ""}
      onClick={() => {
        setOpenMenu(null);
        handleSelect("dashboard");
      }}
    >
      Dashboard
    </li>

     <li
      className={selectedOption === "createInvoice" ? "active" : ""}
      onClick={() => {
        setOpenMenu(null);
        handleSelect("createInvoice");
      }}
    >
      Create Bill For Stock Out
    </li> 


     <li
      className={selectedOption === "viewAllInvoice" ? "active" : ""}
      onClick={() => {
        setOpenMenu(null);
        handleSelect("viewAllInvoice");
      }}
    >
      View All Bill For Stock Out
    </li> 






    {/* Supplier Dropdown */}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "supplier" ? null : "supplier");
      }}
    >
      Supplier ▾

      {openMenu === "supplier" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <p onClick={() => handleSelectSupplier("addSupplier")}>Add Supplier</p>
          <p onClick={() => handleSelectSupplier("viewSupplier")}>View Supplier</p>
        </div>
      )}
    </li>


     <li
      className={selectedOption === "quickAdd" ? "active" : ""}
      onClick={() => {
        setOpenMenu(null);
        handleSelect("quickAdd");
      }}
    >
      Add Stock
    </li> 





    {/* Reports Dropdown */}
    <li
      className="dropdown"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(openMenu === "report" ? null : "report");
      }}
    >
      Reports ▾

      {openMenu === "report" && (
        <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <p onClick={() => handleSelectReport("StockHistory")}>Stock Report</p>
          <p onClick={() => handleSelectReport("viewStockOut")}>View Stock-Out Report</p>
        </div>
      )}
    </li>



  

    {/* Logout */}
    <li
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenu(null);
        handleLogout();
      }}
    >
      Logout
    </li>
  </ul>
</nav>

      {/* 🔵 PAGE BODY */}
      <div className="page-body">





{/******************************************** view All Invoice *************************************************************/}
{selectedOption === "viewAllInvoice" && (
  <div className="view-invoices-container">

    <div className="view-invoice-header">
      <h2>All Bills</h2>
      <p>View, Manage & Delete Customer Bills</p>
    </div>

    {loadingInvoices ? (
      <div className="invoice-loading">
        Loading Bills...
      </div>
    ) : allInvoices.length === 0 ? (
      <div className="empty-invoices">
        No Bills found
      </div>
    ) : (
      <div className="invoice-table-wrapper">
        <table className="invoice-table">
          <thead>
            <tr>
              <th>Bill No</th>
              <th>Frame</th>
              <th>Brand</th>
              <th>Selling Price</th>
              <th>Discount</th>
              <th>Grand Total</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {allInvoices.map((invoice, index) => (
              <tr key={index}>
                <td>{invoice.invoiceNumber}</td>

                <td>
                  {invoice?.products?.frame?.model || "-"}
                </td>

                <td>
                  {invoice?.products?.frame?.brand || "-"}
                </td>


                <td>
                  {invoice?.products?.frame?.sellingPrice || "-"}
                </td>

                <td>
                  {invoice?.discount || "-"}
                </td>

                <td>
                  {invoice?.totalAmount || "-"}
                </td>

                <td>
                  {invoice.createdAt
                    ? new Date(invoice.createdAt).toLocaleDateString()
                    : "-"}
                </td>

                <td>
                  <div className="invoice-action-buttons">

                    <button
                      className="view-btn"
                      onClick={() => handleViewInvoice(invoice)}
                    >
                      👁 View
                    </button>

                    <button
                      className="delete-btn"
                      onClick={() => handleDeleteInvoice(invoice)}
                    >
                      🗑 Delete
                    </button>

                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}

    {/* VIEW MODAL */}
    {showInvoiceModal && selectedInvoice && (
      <div className="invoice-modal-overlay">
        <div className="invoice-modal">

          <div className="invoice-modal-top">
            <h2>Bill Details</h2>

            <button
              className="close-modal-btn"
              onClick={() => setShowInvoiceModal(false)}
            >
              ✖
            </button>
          </div>

          <div className="invoice-modal-content">

            <div className="invoice-detail-grid">

              <div className="invoice-detail-card">
                <span>Bill No</span>
                <strong>{selectedInvoice.invoiceNumber}</strong>
              </div>




              <div className="invoice-detail-card">
                <span>Frame Model</span>
                <strong>
                  {selectedInvoice?.products?.frame?.model || "-"}
                </strong>
              </div>

              <div className="invoice-detail-card">
                <span>Brand</span>
                <strong>
                  {selectedInvoice?.products?.frame?.brand || "-"}
                </strong>
              </div>

              <div className="invoice-detail-card">
                <span>Colour</span>
                <strong>
                  {selectedInvoice?.products?.frame?.colour || "-"}
                </strong>
              </div>







            </div>

          </div>

        </div>
      </div>
    )}

  </div>
)}




{/*************************************************************** Add Supplier******************************************************/}
 
   {selectedOption === "addSupplier" && (
  <div className="add-supplier-container">
    <div className="add-supplier-card">
      <h2>Add Supplier</h2>

      {/* Supplier Name */}
      <label>Supplier Name *</label>
      <input
        type="text"
        value={supplierName}
        onChange={(e) => setSupplierName(e.target.value)}
        placeholder="Enter supplier name"
      />

      {/* Email */}
      <label>Email</label>
      <input
        type="email"
        value={supplierEmail}
        onChange={(e) => setSupplierEmail(e.target.value)}
        placeholder="Enter email"
      />

      {/* Phone */}
      <label>Phone *</label>
      <input
        type="tel"
        value={supplierPhone}
        onChange={(e) => setSupplierPhone(e.target.value)}
        placeholder="Enter phone number"
      />

      {/* Company */}
      <label>Company *</label>
      <input
        type="text"
        value={supplierCompany}
        onChange={(e) => setSupplierCompany(e.target.value)}
        placeholder="Enter company name"
      />

      {/* Address */}
      <label>Address *</label>
      <textarea
        value={supplierAddress}
        onChange={(e) => setSupplierAddress(e.target.value)}
        placeholder="Enter address"
        rows="3"
      />

      {/* Buttons */}
      <button onClick={handleClearSupplier}>Clear</button>
      <button onClick={handleAddSupplier}>Add Supplier</button>
    </div>
  </div>
)}




{/******************************************************* DashBoard  *****************************************************************/}

       {selectedOption === "dashboard" && (
  <div className="dashboard-container">
    {isLoadingDashboard ? (
      <div className="loading-spinner">Loading dashboard data...</div>
    ) : (
      <>
        {/* Header with date filters */}
        <div className="dashboard-header">
          <div>
            <h2>Dashboard</h2>
            <p className="subtitle">Welcome back! Here's your business overview</p>
          </div>
        </div>

        {/* KPI Cards */}
        <div className="kpi-grid">
          <div className="kpi-card invoices">
            <div className="kpi-icon">📄</div>
            <div className="kpi-content">
              <div className="kpi-label">Total jobs</div>
              <div className="kpi-value">{dashboardStats.totalInvoices}</div>
            </div>
          </div>
          
          <div className="product-card frames">
            <div className="product-icon">👓</div>
            <div className="product-info">
              <div className="product-label">Frames Sold</div>
              <div className="product-value">{dashboardStats.totalInvoices}</div>
            </div>
          </div>
        </div>

        {/* Frame Stock Section - Scrollable */}
        <div className="frame-stock-section">
          <div className="section-header">
            <h3>📦 Current Frame Stock</h3>
            <span className="stock-count">{availableFrames.length} models</span>
          </div>
          <div className="frame-stock-scroll">
            <table className="frame-stock-table">
              <thead>
                <tr>
                  <th>Model No</th>
                  <th>Brand</th>
                  <th>Colour</th>
                  <th>Selling Price</th>
                  <th>Available Qty</th>
                </tr>
              </thead>
              <tbody>
                {availableFrames.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="empty-stock">No frames in stock</td>
                  </tr>
                ) : (
                  availableFrames.map((frame, index) => (
                    <tr key={index}>
                      <td>{frame.modelNo}</td>
                      <td>{frame.brand}</td>
                      <td>{frame.colour}</td>
                      <td>{frame.sellingPrice || "-"}</td>
                      <td>
                        {frame.totalQty}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Top Products & Recent Invoices */}
        <div className="two-column-grid">
          {/* Top Products */}
          <div className="info-card">
            <div className="card-header">
              <h3>🏆 Top Selling Products</h3>
            </div>
            <div className="card-body">
              {dashboardStats.topProducts.length === 0 ? (
                <div className="empty-state">No products sold yet</div>
              ) : (
                <div className="top-products-list">
                  {dashboardStats.topProducts.map((product, index) => (
                    <div key={index} className="product-item">
                      <div className="product-rank">{index + 1}</div>
                      <div className="product-name">{product.name}</div>
                      <div className="product-count">{product.count} units</div>
                      <div className="product-bar">
                        <div 
                          className="product-bar-fill" 
                          style={{ 
                            width: `${(product.count / dashboardStats.topProducts[0].count) * 100}%`,
                            backgroundColor: index === 0 ? '#4CAF50' : index === 1 ? '#2196F3' : '#FF9800'
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    )}
  </div>
)}



{/******************************************************* create Invoice *****************************************************************/}


{selectedOption === "createInvoice" && (

    <>
      {showSuccess && (
        <div className="toast-notification">
          ✓ successfully Updated Stock!
        </div>
      )}
      
      <div className="invoice-wrap">
        <div className="invoice-header">
          <h2>Create Bill For Stock Out</h2>
          <p className="invoice-subtitle">Fill in all required fields (*) to generate order</p>
          <div className="invoice-number-display">Next Bill: {currentInvoiceNumber}</div>
        </div>

        <div className="invoice-content">


          {/* Lens & Frame */}
          <div className="invoice-section">
            <div className="section-header">
              <h3>Frame Details</h3>
              <span className="section-badge">Products</span>
            </div>
            

           <div className="form-row">
          



              <div className="form-group">
                <label>Frame Model <span className="required-star">*</span></label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="text"
                    name="frameModel"
                    value={frameSearchTerm}
                    onChange={(e) => handleFrameSearch(e.target.value)}
                    onFocus={() => frameSearchTerm.length >= 2 && setShowFrameSuggestions(true)}
                    placeholder="Type frame model..."
                    className={errors.frameModel ? 'error-input' : ''}
                  />
                  {errors.frameModel && <span className="error-message">{errors.frameModel}</span>}
                  
{showFrameSuggestions && frameSuggestions.length > 0 && (
  <div className="suggestions-dropdown">
    {frameSuggestions.map((frame, index) => (
      <div 
        key={index}
        className="suggestion-item"
        onClick={() => selectFrame(frame)}
      >
        <strong>{frame.modelNo}</strong>
        <div className="suggestion-details">
          {frame.brand} | {frame.colour} 
          <span className="stock-badge">Total Stock: {frame.totalQty}</span>
        </div>
      </div>
    ))}
  </div>
)}
                </div>
              </div>
              
              <div className="form-group">
                <label>Brand</label>
                <input 
                  type="text" 
                  name="brand"
                  value={formData.brand}
                  readOnly
                  className="readonly-field"
                  placeholder="Auto-filled from frame"
                />
              </div>
              
              <div className="form-group">
                <label>Colour</label>
                <input 
                  type="text" 
                  name="colour"
                  value={formData.colour}
                  readOnly
                  className="readonly-field"
                  placeholder="Auto-filled from frame"
                />
              </div>



 {/* SELLING PRICE */}
<div className="form-group">
  <label>Selling Price</label>

  <input
    type="number"
    name="sellingPrice"
    value={formData.sellingPrice}
    readOnly
    className="readonly-field"
    placeholder="Auto-filled from frame"
  />
</div>


{/* DISCOUNT */}
<div className="form-group">
  <label>Discount Amount</label>

  <input
    type="number"
    name="discount"
    value={formData.discount}
    onChange={handleInputChange}
    placeholder="Enter discount"
  />
</div>


{/* TOTAL */}
<div className="form-group">
  <label>Total Amount</label>

  <input
    type="number"
    name="totalAmount"
    value={formData.totalAmount}
    readOnly
    className="readonly-field"
    placeholder="Total amount"
  />
</div>




            </div>
          </div>



          {/* Actions */}
          <div className="invoice-actions">
            <button className="btn-save" onClick={handleSaveOrder} disabled={isLoading}>
              {isLoading ? '⏳ Saving...' : '💾 Save Order'}
            </button>
            <button className="btn-clear" onClick={handleResetForm}>
              🗑️ Clear Form
            </button>
          </div>
        </div>
      </div>
    </>
)}








{/**************************************************** stock history report *******************************************/}


{selectedOption === "StockHistory" && (
  <div className="stock-history-wrap">
    {/* HEADER */}
    <div className="history-header">
      <h2>Stock History ({filteredFrameHistory.length} records)</h2>
      <button onClick={exportToExcel} className="export-excel-btn">
        📊 Export to Excel
      </button>
    </div>

    {/* SUMMARY SECTION WITH SCROLL BAR */}
    <div className="summary-section">
      <div className="summary-header">
        <h3>📦 Frame Stock Summary</h3>
        
        {/* SEARCH BAR */}
        <div className="summary-search">
          <input
            type="text"
            placeholder="🔍 Search by Brand, Color, Model No, or Item Code..."
            value={summarySearchTerm}
            onChange={(e) => setSummarySearchTerm(e.target.value)}
            className="summary-search-input"
          />
          {summarySearchTerm && (
            <button 
              onClick={() => setSummarySearchTerm("")} 
              className="clear-search-btn"
            >
              ✕
            </button>
          )}
        </div>
      </div>

      <div className="summary-scroll-container">
        <table className="summary-table">
          <thead>
            <tr>
              <th>Model No</th>
              {/* <th>Item Code</th> */}
              <th>Brand</th>
              <th>Color</th>
              <th>Sex</th>
              <th>Available Stock (Qty)</th>
              <th>Last Updated</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {(() => {
              // Group by model number
              const summaryMap = new Map();
              
              filteredFrameHistory.forEach(stock => {
                const items = Array.isArray(stock.items) && stock.items.length > 0
                  ? stock.items
                  : [{
                      // itemCode: stock.itemCode || "-",
                      modelNo: stock.modelNo || "-",
                      brand: stock.brand || "-",
                      colour: stock.colour || "-",
                      sex: stock.sex || "-",
                      qty: stock.qty || 0,
                  
                    }];
                
                items.forEach(item => {
                  const modelKey = item.modelNo || "Unknown Model";
                  
                  if (!summaryMap.has(modelKey)) {
                    summaryMap.set(modelKey, {
                      modelNo: item.modelNo,
                      itemCode: item.itemCode,
                      brand: item.brand,
                      colour: item.colour,
                      sex: item.sex,
                      totalQty: 0,
                      lastUpdated: stock.createdAt?.toDate() || new Date(),
                      stockId: stock.id
                    });
                  }
                  
                  const existing = summaryMap.get(modelKey);
                  existing.totalQty += (item.qty || 0);
                  
                  // Update last updated if this record is newer
                  const currentDate = stock.createdAt?.toDate() || new Date();
                  if (currentDate > existing.lastUpdated) {
                    existing.lastUpdated = currentDate;
                  }
                  
                  // Keep the most recent item details
                  if (currentDate > (existing.lastUpdated || new Date(0))) {
                    existing.itemCode = item.itemCode;
                    existing.brand = item.brand;
                    existing.colour = item.colour;
                    existing.sex = item.sex;
                  }
                });
              });
              
              // Convert to array and filter by search term
              let summaryArray = Array.from(summaryMap.values());
              
              if (summarySearchTerm) {
                const searchLower = summarySearchTerm.toLowerCase();
                summaryArray = summaryArray.filter(item => 
                  item.modelNo?.toLowerCase().includes(searchLower) ||
                  item.itemCode?.toLowerCase().includes(searchLower) ||
                  item.brand?.toLowerCase().includes(searchLower) ||
                  item.colour?.toLowerCase().includes(searchLower)
                );
              }
              
              // Sort by model number
              summaryArray.sort((a, b) => (a.modelNo || "").localeCompare(b.modelNo || ""));
              
              return summaryArray.length > 0 ? (
                summaryArray.map((item, idx) => (
                  <tr key={`summary-${idx}`}>
                    <td><strong>{item.modelNo}</strong></td>
                    <td>{item.itemCode}</td>
                    <td>{item.brand}</td>
                    <td>
                      <span style={{ 
                        display: "inline-block", 
                        width: "12px", 
                        height: "12px", 
                        backgroundColor: item.colour?.toLowerCase() || "#ccc",
                        borderRadius: "2px",
                        marginRight: "6px",
                        border: "1px solid #ddd"
                      }}></span>
                      {item.colour}
                    </td>
                    <td>{item.sex}</td>
                    <td className="qty-cell">{item.totalQty}</td>
                    <td>{item.lastUpdated.toLocaleDateString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    No matching frames found
                  </td>
                </tr>
              );
            })()}
          </tbody>
          <tfoot>
          
          </tfoot>
        </table>
      </div>
    </div>

    {/* FILTER SECTION */}
    <div className="filter-section">
      <div className="filter-controls">
        <label>Filter by Date:</label>

        <select
          value={filterType}
          onChange={(e) => {
            setFilterType(e.target.value);
            if (e.target.value === "all") setFilterValue("");
          }}
          className="filter-select"
        >
          <option value="all">All Records</option>
          <option value="day">Specific Day</option>
          <option value="month">Specific Month</option>
          <option value="year">Specific Year</option>
        </select>

        {filterType === "day" && (
          <input
            type="date"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            className="filter-input"
          />
        )}

        {filterType === "month" && (
          <input
            type="month"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            className="filter-input"
          />
        )}

        {filterType === "year" && (
          <input
            type="number"
            placeholder="Enter year"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            className="filter-input"
            min="2000"
            max="2100"
          />
        )}

        {(filterType !== "all" && filterValue) && (
          <button onClick={resetFilters} className="reset-filter-btn">
            Clear Filter
          </button>
        )}
      </div>

      {/* FILTER INFO */}
      {filterType !== "all" && filterValue && (
        <div className="filter-info">
          Showing data for: {
            filterType === "day"
              ? new Date(filterValue).toLocaleDateString()
              : filterType === "month"
              ? new Date(filterValue).toLocaleString("default", {
                  month: "long",
                  year: "numeric"
                })
              : `Year ${filterValue}`
          }
          <span className="record-count">
            ({filteredFrameHistory.reduce(
              (total, stock) => total + (stock.items?.length || 0),
              0
            )} records)
          </span>
        </div>
      )}



{stockSearchTerm && (
  <div className="filter-info">
    Search Results:{" "}
    <strong>
      {
        filteredFrameHistory.reduce(
          (total, stock) =>
            total + (stock.items?.length || 1),
          0
        )
      }
    </strong>{" "}
    matching records for "
    {stockSearchTerm}"
  </div>
)}



<input
  type="text"
  placeholder="Search Model, Brand, Supplier..."
  value={stockSearchTerm}
  onChange={(e) => setStockSearchTerm(e.target.value)}
  className="filter-input"
  style={{
    minWidth: "260px",
  }}
/>



    </div>

    {/* LOADING */}
    {loading && <div className="loading">Loading...</div>}

    {/* TABLE */}
    {!loading && (
      <div className="history-table-container">
        <table className="history-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Supplier</th>
              <th>Model</th>
              <th>Brand</th>
              <th>Colour</th>
              <th>Sex</th>
              <th>Qty</th>
              <th>Added Qty</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredFrameHistory.length > 0 ? (
              filteredFrameHistory.map(stock => {
                // Safe fallback for items
                const items = Array.isArray(stock.items) && stock.items.length > 0
                  ? stock.items
                  : [{
                      modelNo: stock.modelNo || "-",
                      brand: stock.brand || "-",
                      colour: stock.colour || "-",
                      sex: stock.sex || "-",
                      qty: stock.qty || 0,
                      supplyQty: stock.supplyQty || 0,
                      purchaseDate: stock.purchaseDate || ""
                    }];

                return items.map((item, i) => (
                  <tr key={`${stock.id}-${i}`}>
                    <td>
                      {stock.createdAt?.toDate
                        ? stock.createdAt.toDate().toLocaleDateString()
                        : "N/A"}
                    </td>
                    <td>{stock.supplierName || "-"}</td>
                    <td>{item.modelNo || "-"}</td>
                    <td>{item.brand || "-"}</td>
                    <td>{item.colour || "-"}</td>
                    <td>{item.sex || "-"}</td>
                    <td>{item.qty || 0}</td>
                    <td>{item.supplyQty || 0}</td>
                    <td>
  <button
    className="btn-delete-stock"
    onClick={() => handleDeleteStock(stock.id)}
  >
    Delete
  </button>
</td>
                  </tr>
                ));
              })
            ) : (
              <tr>
                <td colSpan="10" style={{ textAlign: "center" }}>
                  No frame stock history found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )}
  </div>
)}


{/******************************************************* View Supplier *****************************************************************/}

        {selectedOption === "viewSupplier" && (
          <div className="sup-wrap">
      <h2>Supplier Management</h2>

      {/* TOP BAR */}
      <div className="sup-topbar">
        <input
          type="text"
          placeholder="Search supplier..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select onChange={(e) => setSortType(e.target.value)}>
          <option value="newest">Newest</option>
          <option value="az">A - Z</option>
        </select>
      </div>

      {/* TABLE */}
      <table className="sup-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Company</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {currentItems.map((s) => (
            <tr key={s.id}>
              <td>{s.name}</td>
              <td>{s.phone}</td>
              <td>{s.email}</td>
              <td>{s.company}</td>
              <td>
                <button onClick={() => setEditData(s)}>Edit</button>
                <button onClick={() => handleDelete(s.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* PAGINATION */}
      <div className="sup-pagination">
        {[...Array(totalPages)].map((_, i) => (
          <button key={i} onClick={() => setCurrentPage(i + 1)}>
            {i + 1}
          </button>
        ))}
      </div>

      {/* EDIT MODAL */}
      {editData && (
        <div className="sup-modal">
          <div className="sup-modal-box">
            <h3>Edit Supplier</h3>

            <input
              value={editData.name}
              onChange={(e) =>
                setEditData({ ...editData, name: e.target.value })
              }
            />
            <input
              value={editData.phone}
              onChange={(e) =>
                setEditData({ ...editData, phone: e.target.value })
              }
            />
            <input
              value={editData.email}
              onChange={(e) =>
                setEditData({ ...editData, email: e.target.value })
              }
            />
            <input
              value={editData.company}
              onChange={(e) =>
                setEditData({ ...editData, company: e.target.value })
              }
            />
            <textarea
              value={editData.address}
              onChange={(e) =>
                setEditData({ ...editData, address: e.target.value })
              }
            />

            <div className="sup-modal-actions">
              <button onClick={handleUpdate}>Update</button>
              <button onClick={() => setEditData(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
)}




{/******************************************************* Report Section *****************************************************************/}


        {selectedOption === "reports" && <h2>Reports Section</h2>}




{/************************************** view stock - out *****************************************************/}

{selectedOption === "viewStockOut" && (
  <div className="stock-out-container">
    <div className="stock-out-header">
      <h2>Stock Out History</h2>
      <button 
        className="btn-export" 
        onClick={generateStockOutReportPDF}
        disabled={filteredStockOut.length === 0}
      >
        📄 Export to PDF
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by model, brand, customer..."
            value={stockOutSearchTerm}
            onChange={(e) => setStockOutSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>


        <div className="filter-group">
          <label>Date Range:</label>
          <input
            type="date"
            value={stockOutDateRange.start}
            onChange={(e) => setStockOutDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={stockOutDateRange.end}
            onChange={(e) => setStockOutDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetStockOutFilters}>
          🔄 Reset Filters
        </button>
        <button className="btn-refresh" onClick={fetchStockOutHistory}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">


      <div className="summary-card">
        <div className="summary-title">Frames Sold</div>
        <div className="summary-value">{getStockOutSummary().frameTotal}</div>
      </div>

    </div>

    {/* Stock Out Table */}
    {isLoadingStockOut ? (
      <div className="loading-spinner">Loading stock-out history...</div>
    ) : (
      <>
        <div className="stock-out-table-container">
          <table className="stock-out-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Model</th>
                <th>Brand</th>
                <th>Colour</th>
                <th>Bill No</th>
                <th>Out Quantity</th>
                <th>Remaining Stock</th>
          
              </tr>
            </thead>
            <tbody>
              {filteredStockOut.length === 0 ? (
                <tr>
                  <td colSpan="12" style={{ textAlign: 'center' }}>
                    No stock-out records found
                  </td>
                </tr>
              ) : (
                filteredStockOut.map((record) => (
                  <tr key={record.id}>
   <td>
  {record.dateFormatted}
  <br />
  {record.timeFormatted}
</td>
                    <td>
                      <span className={`product-type-badge ${record.productType}`}>
                        {record.productType}
                      </span>
                    </td>
                    <td><strong>{record.productModel}</strong></td>
                    <td>{record.brand || 'N/A'}</td>
                    <td>{record.colour || 'N/A'}</td>
                
                    <td>
                      <span className="invoice-link">{record.invoiceNumber}</span>
                    </td>
                    <td className="text-center">{record.quantity}</td>
                    <td className="text-center">
                      <span className={`stock-badge ${record.remainingStock <= 5 ? 'low-stock' : ''}`}>
                        {record.remainingStock}
                      </span>
                    </td>

                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        
        <div className="stock-out-footer">
          <div className="records-count">
            Showing {filteredStockOut.length} of {stockOutRecords.length} records
          </div>
        </div>
      </>
    )}
  </div>
)}


   



{/***************************************************** quick add stock*************************************************************/}

{selectedOption === "quickAdd" && (
  <div className="quick-add-container">
    <h2>Stock Add</h2>

    {/* Select Category */}
    <label>Category:</label>

    <select
      value={quickSelectedCategory}
      onChange={(e) =>
        setQuickSelectedCategory(e.target.value)
      }
    >
      <option value="frame">Frame</option>
    </select>

    {/* Supplier Name */}
    <label>Supplier Name *</label>

    <select
      value={quickSupplierName}
      onChange={(e) =>
        setQuickSupplierName(e.target.value)
      }
    >
      <option value="">-- Select Supplier --</option>

      {suppliersList.map((supplier) => (
        <option
          key={supplier.id}
          value={supplier.name}
        >
          {supplier.name} - {supplier.company}
        </option>
      ))}
    </select>

    {/* Purchase Date */}
    <label>Stock Add Date *</label>

    <input
      type="date"
      value={quickPurchaseDate}
      onChange={(e) =>
        setQuickPurchaseDate(e.target.value)
      }
    />

    {/* ITEMS TABLE */}
    <div className="stock-items">
      <table>
        <thead>
          <tr className="heading-stock-add">
         
            <th>Model No</th>
            <th>Brand</th>
            <th>Colour</th>
            <th>Sex</th>
            <th>Qty</th>
            <th>Supply Qty</th>
            <th>Selling Price</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {quickItems.map((item, i) => (
            <tr key={i}>


              <td>
                <input
                  type="text"
                  value={item.modelNo}
                  onChange={(e) =>
                    handleQuickItemChange(
                      i,
                      "modelNo",
                      e.target.value
                    )
                  }
                  placeholder="Model No"
                />
              </td>

              <td>
                <input
                  type="text"
                  value={item.brand}
                  onChange={(e) =>
                    handleQuickItemChange(
                      i,
                      "brand",
                      e.target.value
                    )
                  }
                  placeholder="Brand"
                />
              </td>

              <td>
                <input
                  type="text"
                  value={item.colour}
                  onChange={(e) =>
                    handleQuickItemChange(
                      i,
                      "colour",
                      e.target.value
                    )
                  }
                  placeholder="Colour"
                />
              </td>

              <td>
                <select
                  value={item.sex}
                  onChange={(e) =>
                    handleQuickItemChange(
                      i,
                      "sex",
                      e.target.value
                    )
                  }
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">
                    Female
                  </option>
                  <option value="Unisex">
                    Unisex
                  </option>
                </select>
              </td>

              <td>
                <input
                  type="number"
                  value={item.qty}
                  onChange={(e) =>
                    handleQuickItemChange(
                      i,
                      "qty",
                      parseInt(e.target.value) 
                    )
                  }
                  placeholder="Qty"
                />
              </td>

              <td>
                <input
                  type="number"
                  value={item.supplyQty}
                  onChange={(e) =>
                    handleQuickItemChange(
                      i,
                      "supplyQty",
                      parseInt(e.target.value) 
                    )
                  }
                  placeholder="Supply Qty"
                />
              </td>


              {/* SELLING PRICE */}
              <td>
                <input
                  type="number"
                  value={item.sellingPrice}
                  onChange={(e) =>
                    handleQuickItemChange(
                      i,
                      "sellingPrice",
                      parseFloat(e.target.value) 
                    )
                  }
                  placeholder="Selling Price"
                />
              </td>

              <td>
                <button
                  className="btn-remove-row"
                  onClick={() =>
                    handleRemoveQuickItem(i)
                  }
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* ADD ROW */}
    <button
      className="btn-add-row"
      onClick={handleAddQuickItemRow}
    >
      + Add Item
    </button>

    {/* ACTIONS */}
    <div className="quick-actions">
      <button onClick={handleClearQuickForm}>
        Clear
      </button>

      <button
        onClick={handleQuickAddStock}
        disabled={isQuickAdding}
      >
        {isQuickAdding
          ? "Adding..."
          : "Add to Stock"}
      </button>
    </div>
  </div>
)}


{/******************************************************* Search *****************************************************************/}


        {selectedOption === "about" && <h2>About</h2>}


{/******************************************************* Log Out *****************************************************************/}


        {selectedOption === "logout" && <h2>Logging Out…</h2>}
      </div>
    </>
  );
}

export default InventoryAdminPanel;